import React from 'react';
import Sentry from 'Integrations/Sentry';
import fr from 'facet-rest';
import './index.css';
import { isNil } from 'Helpers/Utils';

const EmbeddedSalesforceChatForOnboarding = ({
  clientResource,
}) => {
  function handleMobilePosition(e) {
    const messageButton = document.getElementById('embeddedMessagingConversationButton');
    const messagingFrame = document.getElementById('embeddedMessagingFrame');

    if (e.matches && messageButton) {
      messageButton.style.top = '10px';
    }

    if (e.matches && messagingFrame) {
      messagingFrame.style.top = '10px';
    }

    if (!e.matches && messageButton) {
      messageButton.style.top = 'unset';
    }

    if (!e.matches && messagingFrame) {
      messagingFrame.style.top = 'unset';
    }
  }

  function initESWForUpdatedChat() {
    window.embeddedservice_bootstrap.settings.language = 'en_US';

    const mediaQuery = window.matchMedia('(max-width: 600px)');
    mediaQuery.addEventListener('change', handleMobilePosition);

    window.addEventListener('onEmbeddedMessagingReady', () => {
      const householdId = clientResource.attr('householdId');
      const inAppConciergeScheduleUrl = clientResource.relationship(fr.relationships.inAppConciergeSchedule.name)?.link('related').url();

      if (householdId === '' || !householdId) {
        Sentry.createSentryErrorLog(new Error('Household id not set when initializing salesforce chat'));
      }

      // Send data to Salesforce
      window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({ householdId, inAppConciergeScheduleUrl });
    });

    window.addEventListener('onEmbeddedMessagingButtonCreated', () => {
      const messageButton = document.getElementById('embeddedMessagingConversationButton');
      if (window.matchMedia('(max-width: 600px)').matches && messageButton) {
        // Apply new styles to move it
        messageButton.style.top = '10px';
        messageButton.style.right = '15px';
      }
    });

    window.embeddedservice_bootstrap.init(
      process.env.SF_ORG_ID,
      process.env.SF_CHAT_NAME_ONBOARDING_CHAT,
      process.env.SF_ORG_URL2_ONBOARDING_CHAT,
      { scrt2URL: process.env.SF_SCRT_URL },
    );
  }

  React.useEffect(() => {
    if (!clientResource) return;

    if (clientResource.isTruthy('hasHouseholdCompletedOnboarding')) {
      return;
    }

    let s;
    if (!window.embeddedservice_bootstrap) {
      s = document.createElement('script');

      s.setAttribute('src', process.env.SF_CHAT_MIN_JS_URL_ONBOARDING_CHAT);
      // eslint-disable-next-line func-names
      s.onload = function () {
        initESWForUpdatedChat();
      };
      document.body.appendChild(s);
    }

    if (window.embeddedservice_bootstrap) {
      // this is different from the embedded snippet. this, for some reason, works, while the value that Salesforce
      // provides in their embedded snippet code, does not.
      // ¯\_(ツ)_/¯
      initESWForUpdatedChat();
    }

    if (!isNil(s)) {
      // eslint-disable-next-line consistent-return
      return () => {
        document.body.removeChild(s);
      };
    }
  }, [clientResource, window.embedded_svc, window.embeddedservice_bootstrap]);

  return <></>;
};

export default EmbeddedSalesforceChatForOnboarding;
